import { render, staticRenderFns } from "./omt-h4.vue?vue&type=template&id=5bec06d4&"
var script = {}
import style0 from "./omt-h4.vue?vue&type=style&index=0&sc=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports